import React, {useCallback, useEffect, useState} from "react";
import AccountVerificationV2_1 from "./layout_1";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {globalBrandConfigState, globalBreadCrumbState, globalNotificationState} from "../../../_common/global_state";
import {useDeepLinkParams} from "../../../_common/useDeepLinkParams";
import {useGetUserVerificationHistories, useGetUserVerificationProfile} from "../function/accountVerification";
import {Spin} from "antd";
import {
    useGetUserVerificationAccessRightsList,
    useGetUserVerificationFlows,
    useGetUserVerificationTiers
} from "../function/verificationSettings";
import {verificationRefetchState} from "../state";
import AccountVerificationV2_2 from "./layout_2";
import AccountVerificationV2_3 from "./layout_3";

export default function AccountVerificationV2() {
    const brandConfigState = useRecoilValue(globalBrandConfigState);
    const { params: deepLinkParams, clearDeepLink } = useDeepLinkParams();
    const [deepLinkTab] = useState(deepLinkParams.tab);
    const [deepLinkId] = useState(deepLinkParams.id);
    const setGlobalBreadCrumbState = useSetRecoilState(globalBreadCrumbState);
    const setNotificationMessage = useSetRecoilState(globalNotificationState);
    const setVerificationRefetch = useSetRecoilState(verificationRefetchState);

    const {
        data: userVerificationHistories,
        getUserVerificationHistories,
        refetchUserVerificationHistories
    } = useGetUserVerificationHistories();
    const {
        data: userVerificationFlows,
        getUserVerificationFlows,
        refetchUserVerificationFlows
    } = useGetUserVerificationFlows();
    const {
        data: userVerificationTiers,
        getUserVerificationTiers,
        refetchUserVerificationTiers
    } = useGetUserVerificationTiers();
    const {
        data: userVerificationProfile,
        getUserVerificationProfile,
        refetchUserVerificationProfile
    } = useGetUserVerificationProfile();
    const {data: accessRightsList, getUserVerificationAccessRightsList} = useGetUserVerificationAccessRightsList()

    const [isLoading, setIsLoading] = useState(true);

    const preload = useCallback(async () => {
        try {
            setIsLoading(true);

            await Promise.all([
                getUserVerificationFlows(),
                getUserVerificationProfile(),
                getUserVerificationTiers({
                    populate: ["documentSettings"]
                }),
                getUserVerificationHistories(),
                getUserVerificationAccessRightsList()
            ])

        } catch (e) {
            console.error(e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the account verification page. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        } finally {
            setIsLoading(false);
        }
    }, [getUserVerificationFlows, getUserVerificationProfile, getUserVerificationTiers, getUserVerificationHistories, setNotificationMessage])

    useEffect(() => {
        preload();
    }, [preload])

    useEffect(() => {
        if (deepLinkTab || deepLinkId) {
            clearDeepLink();
        }
        setGlobalBreadCrumbState([
            {
                name: "Home",
                path: "/dashboard",
            },
            {
                name: "Verification",
                path: "/account-verification",
            },
        ]);
    }, []);

    useEffect(() => {
        setVerificationRefetch({
            refetchUserVerificationProfile,
            refetchUserVerificationFlows,
            refetchUserVerificationTiers,
            refetchUserVerificationHistories,
        });
    }, [
        refetchUserVerificationProfile,
        refetchUserVerificationFlows,
        refetchUserVerificationTiers,
        refetchUserVerificationHistories,
        setVerificationRefetch
    ]);

    if (isLoading) {
        return (
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px"}}>
                <Spin size="large"/>
            </div>
        );
    }

    let component;

    const props = {
        userVerificationFlows,
        getUserVerificationFlows,
        userVerificationProfile,
        refetchUserVerificationProfile,
        userVerificationTiers,
        refetchUserVerificationTiers,
        getUserVerificationTiers,
        userVerificationHistories,
        refetchUserVerificationHistories,
        accessRightsList,
        deepLinkTab,
        deepLinkId,
    }

    switch (brandConfigState?.defaultLayout) {
        case 1:
            component = <AccountVerificationV2_1{...props}/>
            break;

        case 2:
            component = <AccountVerificationV2_2{...props}/>
            break;

        case 3:
            component = <AccountVerificationV2_3{...props}/>
            break;

        default:
            return null
    }


    return component;
}